module.exports = "/wwwroot/img/two_column_content_block.png?ver=571553f0";